import { useMemo } from 'react';
import { ContractListItem } from '../types/contract';
import { SelectItem } from '../types/core';
import { UserOperator } from '../types/user';
import dayjs, { Dayjs } from 'dayjs';

export const createContractSelectOptions = (
  fetchedContracts: ContractListItem[],
  userOperator: UserOperator | null,
  date?: Dayjs,
) => {
  const contracts: ContractSelectItem[] = [];
  const contractsMap: Record<string, ContractSelectItem> = {};
  date = date?.isValid() ? date : dayjs();

  fetchedContracts.forEach(contract => {
    const [startDate, endDate] = [contract.startDate, contract.endDate].map(
      dateString => dayjs(dateString),
    );
    const selectItem: ContractSelectItem = {
      value: contract.id,
      label:
        // If the user operator is provided, no need to add the operator name to the label
        (!userOperator ? `${contract.operatorName ?? ''} - ` : '') +
        contract.name,
      operatorId: contract.operatorId,
      issue: date.isBefore(startDate, 'day')
        ? 'not-started'
        : date.isAfter(endDate, 'day')
          ? 'expired'
          : null,
    };
    contractsMap[contract.id] = selectItem;

    if (!userOperator || userOperator.operatorId === selectItem.operatorId) {
      contracts.push(selectItem);
    }
  });

  return { contracts, contractsMap };
};

export interface ContractSelectItem extends SelectItem {
  operatorId: string;
  issue: null | 'not-started' | 'expired';
}

const useContractSelectOptions = (
  fetchedContracts: ContractListItem[],
  userOperator: UserOperator | null,
  date?: Dayjs,
) => {
  return useMemo(() => {
    return createContractSelectOptions(fetchedContracts, userOperator, date);
  }, [date, fetchedContracts, userOperator]);
};

export default useContractSelectOptions;
